export * from './Common';
export * from "./Global/service-registred-record";
export * from './Global/app-settings';
export * from './Global';
export * from './HelpDesk';
export * from './Utility';
export * from './Notification';
export * from './Localization';
export * from './Telegram';

import GlobalService from './Global/global-service';
export { GlobalSymbols } from './Global/global-service';

export default GlobalService;